require('./command.js');

PegasusTemplate.GlobalManipulationCommand = PegasusTemplate.Command.extend({
  backup: null,
  descriptionClass: 'styles',
  makeBackup: function(){
    var backup = PegasusTemplate.loadedTemplate().generateOutput(false).editor_cookie;
    this.set('backup', backup);
  },
  execute: function(isInitial){
    var sup = this._super.bind(this);

    PegasusTemplate.set('options.template', this.get('sourceElement'));

    // we don't need to execute this command on creation
    if ( ! isInitial ) {
      PegasusTemplate.get('options').afterLoad = sup;
      PegasusTemplate.lookupRouter().transitionTo('loading');
      PegasusTemplate.stateMachine.initialize();
    } else {
      sup();
    }
  },
  unexecute: function(){
    var sup = this._super.bind(this);

    PegasusTemplate.set('options.template', this.get('backup'));
    PegasusTemplate.get('options').afterLoad = sup;
    PegasusTemplate.lookupRouter().transitionTo('loading');
    PegasusTemplate.stateMachine.initialize();
  }
});
